import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import SportsWidget from '../Views/cric_scorecard/SportsWidget';
import Welcome from '../Views/welcome';
import qs from 'qs';
import CricIndex from '../Views/cric_scorecard/criclayout';
import ElectionLayout from '../Views/election/electionlayout';
import DescriptionLayout from '../Views/description/descriptionlayout';
import TestMatch from '../Views/cric_scorecard/TestMatch';

export default class AppRoutes extends React.Component {

    render() {
      
        let params = qs.parse(window.location.search, { ignoreQueryPrefix: true });

        if (Object.keys(params).length >= 3) {
            return (
                <div id="cricMtchCont">
                    <Router>
                        <Switch>
                            {/* <Route path={'/testmatch'} component={TestMatch}/> */}
                            <Route path={'/matchdetails'} render={(props) => <TestMatch {...props} queryparams={params} />} />
                            <Route path={'/sports'} render={(props) => <CricIndex {...props} queryparams={params} />} />
                            <Route path={'/election'} render={(props) => <ElectionLayout {...props} queryparams={params} />} />
                            <Route path={'/description'} render={(props) => <DescriptionLayout {...props} queryparams={params} />} />
                        </Switch>
                    </Router>
                </div>
            )
        } else {
            return (<div>
                <Switch>
                    <Route path={'/'} component={Welcome} />
                </Switch>
            </div>)
        }

    }
}